import React from 'react';
import { Upload } from 'antd';

export const LCUpload =(props)=>
    <Upload {...props}>{props.children}</Upload>;